import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AlertService } from '@services/helpers/alert.service';
import moment from 'moment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-alter',
  templateUrl: './alter.component.html',
  styleUrls: ['./alter.component.scss'],
})
export class AlterComponent {
  private subscription: Subscription;
  message: any;
  mfa_error: boolean = false;

  constructor(
    private alertService: AlertService,
    private route: Router,
    private Auth: AuthService
  ) {}
  mfa_day: any;
  ngOnInit(): void {
    this.alertService?.getAlerts()?.subscribe(message => {
      this.message = message;
      setTimeout(() => {
        this.message = null;
      }, 3500);
    });
    this.alertService.getMfaError()?.subscribe(param => {
      this.mfa_error = param == null || param?.authentication_type ? false : true;

      if (this.mfa_error) {
        let today = moment().format('YYYY-MM-DD');
        let grace_period_end = moment(param?.grace_period_end);
        this.mfa_day = grace_period_end.diff(today, 'days');

        if (this.mfa_day <= 0) {
          this.mfa_error = false;
          this.Auth.logOut();
        }
      }
    });
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  enableMFA() {
    this.route.navigateByUrl(`/setting/profile/info?id=${'mfa_assigned'}`);
  }
}
